export default __webpack_public_path__ + "static/media/excel.4fb8606c.png";